module.exports = __webpack_public_path__ + "static/media/hospital.164f4a5f.svg";